import { useDeleteTermin } from '@/domain/termine/hooks/useDeleteTermin';
import { Termin } from '@/domain/termine/shared/types';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from 'react-i18next';

export function useTerminDeleteHandler(termin: Termin) {
  const { t } = useTranslation();
  const { deleteTermin, loading } = useDeleteTermin();
  const isDeleteDisabled =
    termin.hasHiddenSchichten || termin.hasHiddenArbeitszeiten;

  const handleDelete = async () => {
    if (isDeleteDisabled) {
      return false;
    }
    const deleteResult = await deleteTermin(termin.id);
    if (deleteResult?.error) {
      toast({
        variant: 'destructive',
        title: t('domain.termine.deleteDialog.deleteTerminFailure'),
        description: t('domain.termine.deleteDialog.error.description', {
          name: termin.titel,
        }),
      });
      return false;
    }

    toast({
      title: t('domain.termine.deleteDialog.deleteTermin'),
      description: t('domain.termine.deleteDialog.success.description', {
        name: termin.titel,
      }),
    });
    return true;
  };
  return { handleDelete, loading, isDeleteDisabled };
}
